import { format, isSameDay } from 'date-fns';
import React from 'react';
import { MessageSimple, useMessageContext } from 'stream-chat-react';

enum CustomMessageType {
  STORY_REPLY = 1,
}

export const CustomMessage = (props) => {
  const messageContext = useMessageContext('MessageSimple');

  const { message } = messageContext;

  if (message.customMessageType === CustomMessageType.STORY_REPLY) {
    return (
      <div className="chat-story-reply">
        <span className="text-gray-400 text-xs font-semibold">
          Replied to your story
        </span>
        {(message.attachments?.[0]?.asset_url ||
          message.attachments?.[0]?.image_url) && (
          <div className="str-chat__message-attachment str-chat__message-attachment--image str-chat__message-attachment--image str-chat__message-attachment--image-- border-l-4 border-gray-200 pl-3">
            <img
              className="str-chat__message-attachment--img cursor-auto"
              src={
                message.attachments?.[0]?.asset_url ||
                message.attachments?.[0]?.image_url
              }
            />
          </div>
        )}
        <MessageSimple
          {...{
            ...messageContext,
            ...props,
            message: {
              ...message,
              attachments: [],
            },
          }}
        />
      </div>
    );
  }
  return <MessageSimple {...messageContext} {...props} />;
};
